import { render, staticRenderFns } from "./DepositTermsView.vue?vue&type=template&id=51b8ee10&lang=pug&"
import script from "./DepositTermsView.vue?vue&type=script&lang=js&"
export * from "./DepositTermsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports